@if (!isSelfService() && !isManagementView()) {
    @if (showHeader() && !isFullscreen() && !maintenanceMode) {
        <app-header></app-header>
    }
    <!-- `min-h-full` neben `h-full`: Eine feste Höhe allein schneidet Inhalt
         ab, der nicht in kleine Fenster passt — dann ist z. B. der unterste
         Seitenleisten-Eintrag im Admin nicht einmal per Mausrad erreichbar.
         Mit Mindesthöhe wächst die Seite und scrollt normal. Im Fullscreen
         (addons-only) bleibt der Wrapper unformatiert. -->
    <div
        [class.tw-flex]="!isFullscreen()"
        [class.tw-flex-col]="!isFullscreen()"
        [class.tw-justify-between]="!isFullscreen()"
        [class.tw-h-full]="!isFullscreen()"
        [class.tw-min-h-full]="!isFullscreen()">
        <!-- `h-full` gibt Tabellenseiten die feste Höhe, die sie für ihr
             internes Scrollen brauchen. Vertikal deshalb `overflow-y-auto`
             und nicht `overflow-hidden`: Seiten, die höher sind als der
             Viewport (z. B. das Standort-Formular im Admin), wären sonst
             unterhalb der Kante abgeschnitten und nicht erreichbar, weil die
             Höhenkette bis hierher auf die Viewport-Höhe begrenzt ist.
             Horizontal bleibt es geschnitten, damit breite Tabellen weiterhin
             nur in ihrem eigenen Container scrollen. -->
        <div
            [class.tw-mx-6]="!isFullscreen() && !maintenanceMode"
            [class.tw-mt-[80px]]="!isFullscreen() && !maintenanceMode"
            [class.tw-pb-10]="!isFullscreen() && !maintenanceMode"
            [class.tw-flex-grow]="!isFullscreen() && !maintenanceMode"
            [class.tw-rounded-xl]="!isFullscreen() && !maintenanceMode"
            [class.tw-h-full]="!isFullscreen() && !maintenanceMode"
            [class.tw-overflow-y-auto]="!isFullscreen() && !maintenanceMode"
            [class.tw-overflow-x-hidden]="!isFullscreen() && !maintenanceMode"
            [class.tw-bg-white]="!maintenanceMode">
            <router-outlet></router-outlet>
        </div>
        @if (!isFullscreen()) {
            <app-global-footer
                class="tw-z-10"
                [footerVisibility]="false">
            </app-global-footer>
        }
    </div>
} @else if (isSelfService()) {
    <div
        class="tw-h-svh tw-flex tw-flex-col"
        #contentArea>
        <div class="tw-w-svh tw-h-screen tw-overflow-hidden tw-bg-white">
            <router-outlet></router-outlet>
        </div>
        <app-selfservice-footer
            [footerVisibility]="true"></app-selfservice-footer>
    </div>
} @else {
    <div
        class="tw-h-svh tw-flex tw-flex-col"
        #contentArea>
        <div class="tw-w-svh tw-h-screen tw-overflow-hidden tw-bg-white">
            <router-outlet></router-outlet>
        </div>
    </div>
}

@if (!isProduction() && isLoggedIn()) {
    <app-debug-toggle></app-debug-toggle>
}

<ngx-spinner
    bdColor="rgba(0, 0, 0, 0.5)"
    size="medium"
    color="#ffffff"
    type="ball-scale-multiple"
    [fullScreen]="true">
</ngx-spinner>
